import React, { PureComponent } from 'react'
import { Dropdown } from 'semantic-ui-react'

import { COUNTRIES } from '../../constants'

const countryOptions = [
  { key: '__blank', text: 'Не выбрана', value: null },
  ...COUNTRIES.map(({ code, name }) => ({
    key: code,
    value: code,
    flag: code.toLowerCase(),
    text: name,
  })),
]

export default class CountriesDropdown extends PureComponent {
  handleChange = (_, { value }) => this.props.onChange(value)

  render() {
    const { value, name } = this.props

    return (
      <Dropdown
        placeholder='Выберите страну'
        fluid
        search
        selection
        name={name}
        options={countryOptions}
        value={value}
        onChange={this.handleChange}
      />
    )
  }
}
